import { openDB } from 'idb';

// Constantes para la base de datos
const IMAGE_DB_NAME = 'image-cache';
const IMAGE_STORE_NAME = 'images';

// Inicializa y abre la base de datos
const initDB = async () => {
  return openDB(IMAGE_DB_NAME, 1, {
    upgrade(db) {
      // Crea el object store si no existe
      if (!db.objectStoreNames.contains(IMAGE_STORE_NAME)) {
        db.createObjectStore(IMAGE_STORE_NAME);
      }
    },
  });
};

// Guarda la imagen en IndexedDB
export const saveImageToDB = async (key: string, base64: string) => {
  const db = await initDB();
  await db.put(IMAGE_STORE_NAME, base64, key);
};

// Recupera la imagen desde IndexedDB
export const getImageFromDB = async (key: string): Promise<string | null> => {
  const db = await initDB();
  return db.get(IMAGE_STORE_NAME, key);
};

// Elimina una imagen del almacenamiento
export const deleteImageFromDB = async (key: string) => {
  const db = await initDB();
  await db.delete(IMAGE_STORE_NAME, key);
};
